import { v4 as uuidv4 } from 'uuid';

export function ShippingSimulator(props = {}, childrenComponents = []) {
	return {
		componentName: 'ShippingSimulator',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pricingMode: 'individualItems',
				shouldUpdateOrderForm: true,
			},
			props,
		),
		childrenComponents,
	};
}
